export default __webpack_public_path__ + "assets/front/scss/user-profile.2948c0736c2c4abb0a7e2cd7d52d3a95.css";